/*
 * Anti Parfum — cart sample selector.
 * Two complimentary 2ML samples with any full-size fragrance.
 *
 * Replaces the previous implementation. The MARKUP AND CSS ARE UNCHANGED — this file drives the
 * existing snippet exactly as it stands, so the component looks identical. Only the behaviour is
 * new, because three things were broken and each was reproduced live before this was written:
 *
 *  1. Nothing on this theme fires a `cart:updated` event and it is not Dawn, so the old code
 *     computed locked/unlocked once at page render and never again. Adding a bottle from a product
 *     page left the drawer saying "Add any full-size fragrance to your cart" with one already in it.
 *  2. On a product page the selector was never initialised at all.
 *  3. Selecting samples was unreliable: in the drawer the second pick never registered, and on the
 *     cart page it added the SAME sample twice (bast 2ML x2) instead of two different ones.
 *
 * Design rules, learned the hard way on this account:
 *  - Every listener is delegated from `document`. The snippet renders at two mount points and the
 *    drawer replaces its innerHTML, so element-bound listeners die on re-render.
 *  - Eligibility is recomputed from the LIVE cart every time, never from a page-load snapshot.
 *  - Eligibility uses an explicit variant list from the `full-size-fragrances` collection (tag
 *    driven, auto-maintained). There is NO price heuristic: the old $30 fallback would have
 *    offered free samples alongside a $50 discovery kit or a $40 tester.
 */
(function () {
  'use strict';
  if (window.__jlAntiSampleSelector) return;
  window.__jlAntiSampleSelector = true;

  var MAX = 2;
  var KEY = 'jl:anti:samples';
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var qualifyingVariantIds = null;   // resolved once, then cached
  var busy = false;

  function roots() { return [].slice.call(document.querySelectorAll('.cart-sample-selector')); }

  // The samples are already rendered into the modal by Liquid with data attributes — read them
  // from the DOM rather than duplicating the list in JS.
  function samples() {
    var seen = {}, out = [];
    [].slice.call(document.querySelectorAll('.cart-sample-selector__sample-item')).forEach(function (el) {
      var id = parseInt(el.getAttribute('data-sample-variant-id'), 10);
      if (!id || seen[id]) return;
      seen[id] = true;
      out.push({
        variantId: id,
        productId: parseInt(el.getAttribute('data-sample-id'), 10),
        name: el.getAttribute('data-sample-name') || '',
        size: el.getAttribute('data-sample-size') || '',
        image: (el.querySelector('.cart-sample-selector__sample-image img') || {}).src || '',
        unavailable: el.hasAttribute('data-unavailable')
      });
    });
    return out;
  }
  function byVariant(id) {
    var m = samples().filter(function (s) { return s.variantId === id; });
    return m.length ? m[0] : null;
  }
  function sampleVariantIds() { return samples().map(function (s) { return s.variantId; }); }

  function loadSel() { try { return JSON.parse(sessionStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function saveSel(v) { try { sessionStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  // full-size fragrances, from the tag-driven collection. Cached after the first call.
  function getQualifying() {
    if (qualifyingVariantIds) return Promise.resolve(qualifyingVariantIds);
    return fetch('/collections/full-size-fragrances/products.json?limit=250', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) {
        var ids = [];
        (d.products || []).forEach(function (p) {
          (p.variants || []).forEach(function (v) { ids.push(v.id); });
        });
        qualifyingVariantIds = ids;
        return ids;
      })
      .catch(function () { qualifyingVariantIds = []; return []; });
  }

  function sampleLines(cart) {
    var ids = sampleVariantIds();
    return (cart.items || []).filter(function (i) {
      return (i.properties && i.properties._sample === 'true') || ids.indexOf(i.variant_id) !== -1;
    });
  }

  function cartQualifies(cart, qualifying) {
    var ids = sampleVariantIds();
    return (cart.items || []).some(function (i) {
      if (i.properties && i.properties._sample === 'true') return false;
      if (ids.indexOf(i.variant_id) !== -1) return false;
      return qualifying.indexOf(i.variant_id) !== -1;
    });
  }

  function show(el, on, mode) { if (el) el.style.display = on ? (mode || 'block') : 'none'; }

  function paint(cart, qualifying) {
    var ok = cartQualifies(cart, qualifying);
    var lines = sampleLines(cart);
    var chosen = lines.slice(0, MAX).map(function (l) { return byVariant(l.variant_id); }).filter(Boolean);
    if (!chosen.length) {
      var stored = loadSel();
      chosen = Object.keys(stored).map(function (k) { return stored[k]; }).filter(Boolean);
    }

    roots().forEach(function (root) {
      root.setAttribute('data-qualifying', ok ? 'true' : 'false');
      show(root.querySelector('[data-qualifying-title-unlocked]'), ok, 'inline');
      show(root.querySelector('[data-qualifying-title-locked]'), !ok, 'inline');
      show(root.querySelector('[data-qualifying-counter-unlocked]'), ok, 'inline');
      show(root.querySelector('[data-qualifying-counter-locked]'), !ok, 'inline');
      show(root.querySelector('[data-qualifying-unlocked-ui]'), ok, 'block');

      var counter = root.querySelector('#sample-counter');
      if (counter) counter.textContent = String(chosen.length);
      show(root.querySelector('.cart-sample-selector__change-wrapper'), ok && chosen.length >= MAX, 'block');

      [].slice.call(root.querySelectorAll('.cart-sample-selector__slot')).forEach(function (slot, idx) {
        var s = chosen[idx];
        var ph = slot.querySelector('.cart-sample-selector__placeholder');
        var sel = slot.querySelector('.cart-sample-selector__selected-item');
        if (s) {
          show(ph, false); show(sel, true, 'flex');
          var img = sel.querySelector('.cart-sample-selector__image');
          if (img) { img.src = s.image || ''; img.alt = s.name; }
          var n = sel.querySelector('.cart-sample-selector__item-name');
          var z = sel.querySelector('.cart-sample-selector__item-size');
          if (n) n.textContent = s.name;
          if (z) z.textContent = s.size || '';
        } else {
          show(ph, true, 'flex'); show(sel, false);
        }
      });
    });
  }

  function refresh() {
    return Promise.all([getCart(), getQualifying()])
      .then(function (r) { paint(r[0], r[1]); })
      .catch(function () {});
  }

  // ---- modal ---------------------------------------------------------------
  function openModal(root) {
    var modal = root.querySelector('#sample-selector-modal') || document.getElementById('sample-selector-modal');
    if (!modal) return;
    var sel = loadSel();
    var taken = Object.keys(sel).map(function (k) { return sel[k] && sel[k].variantId; }).filter(Boolean);
    getCart().then(function (cart) {
      sampleLines(cart).forEach(function (l) { taken.push(l.variant_id); });
      [].slice.call(modal.querySelectorAll('.cart-sample-selector__sample-item')).forEach(function (el) {
        var id = parseInt(el.getAttribute('data-sample-variant-id'), 10);
        var off = taken.indexOf(id) !== -1 || el.hasAttribute('data-unavailable');
        el.classList.toggle('disabled', off);
      });
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    });
  }
  function closeModals() {
    [].slice.call(document.querySelectorAll('#sample-selector-modal, .cart-sample-selector__modal'))
      .forEach(function (m) { m.style.display = 'none'; });
    document.body.style.overflow = '';
  }

  function choose(variantId) {
    var s = byVariant(variantId);
    if (!s || s.unavailable) return;
    var sel = loadSel();
    var slots = Object.keys(sel);
    if (slots.length >= MAX) return;
    for (var i = 0; i < slots.length; i++) {
      if (sel[slots[i]] && sel[slots[i]].variantId === variantId) return;  // never the same sample twice
    }
    sel[String(slots.length + 1)] = s;
    saveSel(sel);
    closeModals();
    if (Object.keys(sel).length >= MAX) commit();
    else refresh();
  }

  function commit() {
    if (busy) return;
    busy = true;
    var sel = loadSel();
    var items = Object.keys(sel).slice(0, MAX).map(function (k) {
      return { id: sel[k].variantId, quantity: 1, properties: { _sample: 'true' } };
    });
    if (!items.length) { busy = false; return; }
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function () {
      saveSel({});
      window.location.href = '/cart';
    }).catch(function () { busy = false; });
  }

  function clearSamples() {
    saveSel({});
    getCart().then(function (cart) {
      var lines = sampleLines(cart);
      if (!lines.length) return refresh();
      var updates = {};
      lines.forEach(function (l) { updates[l.key] = 0; });
      return fetch('/cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function () { window.location.reload(); });
    });
  }

  // ---- delegated events ----------------------------------------------------
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.closest('.cart-sample-selector__modal-close') || t.closest('.cart-sample-selector__modal-overlay')) {
      e.preventDefault(); closeModals(); return;
    }
    var pick = t.closest('.cart-sample-selector__sample-item');
    if (pick) {
      e.preventDefault();
      if (pick.classList.contains('disabled')) return;
      choose(parseInt(pick.getAttribute('data-sample-variant-id'), 10));
      return;
    }
    var ph = t.closest('.cart-sample-selector__placeholder');
    if (ph) {
      e.preventDefault();
      var root = ph.closest('.cart-sample-selector');
      if (root) openModal(root);
      return;
    }
    if (t.closest('.cart-sample-selector__remove-button') || t.closest('#change-samples-button')
        || t.closest('.cart-sample-selector__change-button')) {
      e.preventDefault(); clearSamples(); return;
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModals();
    var ph = e.target && e.target.closest && e.target.closest('.cart-sample-selector__placeholder');
    if (ph && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      var root = ph.closest('.cart-sample-selector');
      if (root) openModal(root);
    }
  });

  // ---- stay in step with the cart ------------------------------------------
  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function (input) {
      var url = '';
      try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
      return origFetch.apply(this, arguments).then(function (res) {
        if (url && CART_WRITE.test(url) && url.indexOf('/cart.js') === -1 && res && res.ok) setTimeout(refresh, 200);
        return res;
      });
    };
  }
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) { try { this.__jlUrl = url; } catch (e) {} return origOpen.apply(this, arguments); };
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var x = this;
    x.addEventListener('load', function () {
      if (x.__jlUrl && CART_WRITE.test(x.__jlUrl) && x.status >= 200 && x.status < 300) setTimeout(refresh, 200);
    });
    return origSend.apply(this, arguments);
  };

  function boot() {
    var target = document.querySelector('[data-cart-drawer]') || document.body;
    if (target && !target.__jlObserved) {
      target.__jlObserved = true;
      new MutationObserver(function () { setTimeout(refresh, 80); }).observe(target, { childList: true, subtree: true });
    }
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
